import React, { useContext } from 'react'

const ScheduleContext = React.createContext()

export function ScheduleProvider({ data, children }) {
  // day of the week for Sunday should be 0
  const schedule = data.map((day, idx, arr) => ({
    ...day,
    id: idx === arr.length - 1 ? 0 : idx + 1,
    time: day.is_holiday ? 'выходной' : `c ${day.from} до ${day.to}`,
  }))

  const groupedSchedule = groupSchedule(schedule)
  return (
    <ScheduleContext.Provider value={{ schedule, groupedSchedule }}>
      {children}
    </ScheduleContext.Provider>
  )
}

export function useSchedule() {
  return useContext(ScheduleContext)
}

function groupSchedule(schedule) {
  // return [['time_1', ['Пн', 'Вт', 'Ср', 'Чт', 'Пт']], ['time_2', ['Сб']], ['time_1', ['Вс']]]
  const similarHours = schedule.reduce((acc, item) => {
    const data = item.day

    if (acc.length === 0) {
      acc.push([item.time, [data]])
      return acc
    }

    const [lastItem] = acc.splice(-1, 1)

    const lastItemTime = lastItem?.[0]
    const lastItemDays = lastItem?.[1] ?? []
    const isSimilarToLastTime = item.time === lastItemTime

    if (isSimilarToLastTime) {
      acc.push([lastItemTime, [...lastItemDays, data]])
    } else {
      acc.push(lastItem, [item.time, [data]])
    }

    return acc
  }, [])

  // return [['time_1', 'Пн - Пт'], ['time_2', 'Сб'], ['time_1', 'Вс']]
  const withGroupedDays = similarHours.map((item) => {
    const time = item[0]
    const days = item[1]

    if (days.length > 2) {
      // get first and last day
      return [time, `${days[0]} - ${days[days.length - 1]}`]
    } else {
      return [time, days.join(', ')]
    }
  })

  return withGroupedDays
}
